var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"router-fade","mode":"out-in"}},[_c('div',[_c('router-view'),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.landscape),expression:"landscape"}],staticClass:"landscape"},[_c('section',{staticClass:"alert_box"},[_c('span',[_vm._v("请使用竖屏打开")])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }